import { render, staticRenderFns } from "./OwnOrder.vue?vue&type=template&id=9f4e3e46&scoped=true&"
import script from "./OwnOrder.vue?vue&type=script&lang=js&"
export * from "./OwnOrder.vue?vue&type=script&lang=js&"
import style0 from "./OwnOrder.vue?vue&type=style&index=0&id=9f4e3e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4e3e46",
  null
  
)

component.options.__file = "OwnOrder.vue"
export default component.exports